export default __webpack_public_path__ + "media/assets/fonts/roboto-v20-latin-700italic-a86f47625c877fab89fd8d71f8861a21.ttf";